/** `/leads/:id` — the full-page lead view (deep-link target; Stage 2 expands it). */
import { Link, useParams } from 'react-router';
import { ArrowLeft } from 'lucide-react';
import { LeadDetail } from './LeadDetail';

export default function LeadPage() {
  const { id } = useParams<{ id: string }>();
  if (!id) return null;
  return (
    <div className="mx-auto flex h-full max-w-[900px] flex-col px-4 py-4 sm:px-6 sm:py-6">
      <Link
        to="/pipeline"
        className="mb-3 inline-flex min-h-10 w-fit items-center gap-1.5 rounded-md px-2 text-[13px] font-medium text-muted hover:bg-white hover:text-gray-900"
      >
        <ArrowLeft size={15} strokeWidth={2} aria-hidden /> Back to pipeline
      </Link>
      <div className="min-h-0 flex-1 overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
        <LeadDetail leadId={id} headingLevel={1} />
      </div>
    </div>
  );
}
